export default __webpack_public_path__ + "static/media/20.a79790c5.jpg";